import { PaginatorParams } from "@api/models/paginator";

export interface UserHistoryParams extends PaginatorParams{
  entityIds: number[];
}
export interface UserHistoryItem {
  date: Date;
  activity: AuditRootActionEnum;
  activityBy: string | null;
  customerUsers?: CustomerUser[];
  userProfiles?: UserProfile[];
}

export interface PermissionChange {
  permission: string;
  changeType: PermissionChangeTypeEnum;
}

export interface UserProfile {
  customerPermissions: PermissionChange[];
  groupPermissions: PermissionChange[];
  groupName: string | null;
  customerName: string | null;
  groupAction: PermissionChangeTypeEnum;
}

export interface CustomerUser {
  customerName: string;
  userName: string;
  activity: AuditRootActionEnum;
}

export interface ChannelUser {
  channelName: string;
  userName: string;
  activity: AuditRootTableEnum;
}

export interface UserHistoryResponse {
  createdAtUtc: string;
  userName: string;
  activity: AuditRootActionEnum;
  userProfiles?: UserProfile[];
  customerUsers?: CustomerUser[];
  channelUsers?: ChannelUser[];
}


export enum AuditRootActionEnum {
  Unknown = 0,
  Added = 1,
  Modified = 2,
  Deleted = 3,
}

export const AuditRootActionEnumLabels = {
  [AuditRootActionEnum.Added]: 'users.history.action.added',
  [AuditRootActionEnum.Modified]: 'users.history.action.changed',
  [AuditRootActionEnum.Deleted]: 'users.history.action.deleted',
};

export enum AuditRootTableEnum {
  ApplicationUsers = 1,
  Screens = 2,
  Channels = 3,
  CustomerUsers = 4,
  UserProfiles = 5,
  Groups = 6,
  ChannelUsers = 7,
}

export enum PermissionChangeTypeEnum {
  Unchanged = 1,
  Added = 2,
  Removed = 3,
}
